import './components/index.js';

let url = $(location).attr('href').split('/').splice(0, 5).join('/');
let segments = url.split('/');
const slider = document.querySelector('.uk-subnav');
let lang = segments[3];
let two_segment = segments[4];
if ('' === lang) {
	lang = 'ro';
}

function scroll_search() {
	document.querySelector(".popup__input").addEventListener("scroll", function () {
		document.querySelector("input[name='query']").blur();
	});
}

UIkit.util.on('#modal-credit', 'show', function () {
	const body = document.querySelector('#modal-credit .uk-modal-body .block-scroll');
	if (body) body.scrollTop = body.scrollHeight;
});

(function () {
	var secs = document.querySelectorAll('.bf details.bf__sec');
	if (!secs.length) return;

	var mq = window.matchMedia('(max-width: 639px)');

	function sync() {
		secs.forEach(function (d) { d.open = !mq.matches; });
	}

	sync();
	if (mq.addEventListener) mq.addEventListener('change', sync);
	else mq.addListener(sync);

	secs.forEach(function (d) {
		d.querySelector('summary').addEventListener('click', function (e) {
			if (!mq.matches) { e.preventDefault(); return; }
			secs.forEach(function (o) { if (o !== d) o.open = false; });
		});
	});
})();


$(document).ready(function (e) {

	const target = document.querySelector('.header-2');

	let lastScrollY = window.scrollY;
	let isActive = false;

	const MOBILE_WIDTH = 960;
	const DELTA = 125;

// Debounce функция для оптимизации
	function debounce(func, wait) {
		let timeout;
		return function executedFunction(...args) {
			const later = () => {
				clearTimeout(timeout);
				func(...args);
			};
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
		};
	}

// Функция проверки и применения active
	function checkAndApplyActive() {
		if (!target) return;

		const currentScroll = window.scrollY;
		const isMobile = window.innerWidth < MOBILE_WIDTH;
		const headerHeight = target.getBoundingClientRect().height;

		if (isMobile) {
			if (currentScroll >=150) {
				target.classList.add('active');
				isActive = true;
			} else {
				target.classList.remove('active');
				isActive = false;
			}
		} else {
			if (currentScroll > headerHeight) {
				target.classList.add('active');
				isActive = true;
			} else {
				target.classList.remove('active');
				isActive = false;
			}
		}

		lastScrollY = currentScroll;
	}

// Основная функция скролла
	function handleScroll() {
		const currentScroll = window.scrollY;
		const isMobile = window.innerWidth < MOBILE_WIDTH;

		if (Math.abs(currentScroll - lastScrollY) < DELTA) return;

		const headerHeight = target.getBoundingClientRect().height;

		if (isMobile) {
			if (currentScroll === 0) {
				target.classList.add('active');
				isActive = true;
				lastScrollY = currentScroll;
				return;
			}

			if (currentScroll > lastScrollY && !isActive) {
				target.classList.add('active');
				isActive = true;
			}

			if (currentScroll < lastScrollY && isActive) {
				target.classList.remove('active');
				isActive = false;
			}
		}
		else {
			if (currentScroll > headerHeight && !isActive) {
				target.classList.add('active');
				isActive = true;
			}

			if (currentScroll <= headerHeight && isActive) {
				target.classList.remove('active');
				isActive = false;
			}
		}

		lastScrollY = currentScroll;
	}

// Обработчик скролла с throttle
	let ticking = false;
	window.addEventListener('scroll', function() {
		if (!ticking) {
			window.requestAnimationFrame(function() {
				handleScroll();
				ticking = false;
			});
			ticking = true;
		}
	});

// Функция инициализации
	function initHeader() {
		if (!target) return;

		setTimeout(() => {
			checkAndApplyActive();
		}, 100);
	}

// Проверка после полной загрузки страницы
	if (document.readyState === 'complete') {
		initHeader();
	} else {
		window.addEventListener('load', initHeader);
	}

// Проверка при ресайзе (с debounce)
	const debouncedResize = debounce(function() {
		if (target) {
			checkAndApplyActive();
		}
	}, 200);

	window.addEventListener('resize', debouncedResize);

	let body = $('body');
	const track = document.querySelector("header.header .marquee-track");
	if (track) {
		const clone = track.cloneNode(true);
		clone.setAttribute("aria-hidden", "true");
		track.parentNode.appendChild(clone);

		requestAnimationFrame(() => {
			document.querySelector("header.header .marquee").classList.add("animate");
		});
	}

	$(function() {
		let i = 1;
		let input = $("input[name='query']");
		input.click(function() {
			if (i === 1) {
				i++;
				setTimeout(() => {
					$(this).trigger('click');
					// $('.header__search').addClass('header__search__active');
				}, 50);
			}
		});
		input.focusout(function() {
			if (input.val().length == 0) {
				// $('.header__search').removeClass('header__search__active');
				i = 1;
			}
		});
		$(document).on("click", ".mobile-arrow", function() {
			$("input[name='query']").val("");
			// $('.header__search').removeClass('header__search__active');
			i = 1;
		});

		$(document).on('scroll', function() {
			if ($(".popup__search").is(":visible")) {
				$("input[name='query']").val("");
				// $('.header__search').removeClass('header__search__active');
				$('.popup__search').hide();
			}
		});
	});
	$('.preloader').fadeOut(100, function () {
		$('.preloader').remove();
	});

	$('.cl-pop').click(function () {
		$(this).find('.hint').toggle();
		$(this).closest('.detail').toggleClass('active__detail');
	});

	$('.it')
		.find('span span')
		.click(function () {
			let it = $(this).parent().parent();
			it.find('.it_popup').toggle();
			let itIndex = it.index();

			$('.it').each(function (index) {
				if (index !== itIndex) {
					$(this).find('.it_popup').hide();
				}
			});
		});

	$(document).click(function (e) {
		if ($(e.target).parents('.it').length === 0) {
			$('.it_popup').hide();
		}
	});

	$('.breadcrumbs-mob-down').click(function (e) {
		setTimeout(function () {
			$('.breadcrumbs-mob-down').find('.bd-bck').toggle();
			$('.breadcrumbs-mob-down').toggleClass('actv');
		}, 10);
	});

	$(document).scroll(function (e) {
		if ($('.simile').length) {
			if ($(window).scrollTop() > $('.simile').offset().top) {
				$('.simile__top-block').addClass('simile__top-block_fix');
				$('.simile').addClass('simile-fix');
			} else {
				$('.simile__top-block').removeClass('simile__top-block_fix');
				$('.simile').removeClass('simile-fix');
			}
		}
	});

	$('.count-item')
		.find('span')
		.click(function (e) {
			$(this).parent().find('ul').toggle();
			$(this).parent().toggleClass('rt');
		});

	$('.popup__arrow__close').click(function (e) {
		e.preventDefault();
		$('.popup__city').removeClass('popup__open');
	});

	$('.write-review').click(function (e) {
		e.preventDefault();
		$('body').css('position', 'fixed');
		$('.popup__reviews').addClass('popup__open');
	});

	$('.uslov').click(function (e) {
		e.preventDefault();
		$('.popup__text').addClass('popup__open');
	});

	body.off('click', '.quick_order').on('click', '.quick_order', function (e) {
		e.preventDefault();
		$('.popup__quick').addClass('popup__open');
	});

	$('.buy_in_credit').click(function (e) {
		e.preventDefault();
		$('.popup__credit').addClass('popup__open');
	});

	$('.preorder').click(function (e) {
		e.preventDefault();
		$('.popup__preorder').addClass('popup__open');
	});

	$(document).on('click', '.reviews__center .toggle_button', function () {
		$(this).closest('.reviews__center').find('.review__item').show();
		$(this).remove();
	});

	// $(document).on('click', '.personal_data', function (event) {
	// 	event.preventDefault();
	// 	$('.popup__personal').addClass('popup__open');
	// });
	//
	// $(document).on('click', '.terms', function (event) {
	// 	event.preventDefault();
	// 	$('.popup__terms').addClass('popup__open');
	// });

	$('.product__func')
		.find('.table')
		.click(function (e) {
			e.preventDefault();
			$('.popup__table').addClass('popup__open');
		});

	$('.popup__close, .btn5').click(function (e) {
		$('body').css('position', 'initial');
		$(this).closest('.popup').removeClass('popup__open');
	});

	$('.catalog__popup').find('.lft__li').click(function (e) {
		$('.catalog__popup').find('.lft__li').removeClass('lft__li_active');
		$(this).addClass('lft__li_active');
		var indexThis = $(this).index();
		$('.catalog__popup').find('.rht__li-item').each(function (e) {
			if ($(this).index() == indexThis) {
				$('.catalog__popup').find('.rht__li-item').hide();
				$(this).show();
			} else {
				$(this).hide();
			}
		});
	});

	$('.filter__btn').click(function (e) {
		$('.category').show();
		$('body').css('overflow-y', 'hidden');
	});

	$('.category__item .cath4').click(function (e) {
		$(this).toggleClass('h4-op');
	});

	$('.settings__block .cath4').click(function (e) {
		$(this).parent().find('.settings__body').toggle();
		$(this).toggleClass('h4-op');
	});

	$('.category__close').click(function (e) {
		$('.category').hide();
		$('body').css('overflow-y', 'auto');
	});

	$('.sort__block')
		.find('.block__head')
		.click(function (e) {
			$(this).parent().find('.block__body').toggle();
			$(this).toggleClass('h4-op');
		});

	$(document).on('mouseleave', '.sort__block', function () {
		$(this).find('.block__body').hide();
		$(this).find('.block__head').removeClass('h4-op');
	});

	// $('.header__catalog_mob').click(function (e) {
	// 	$('.menu__bgd').show();
	// 	$('body').css('overflow-y', 'hidden');
	// });

	$(document).mouseup(function (e) {
		let tooltip = $('.hint');
		if (!tooltip.is(e.target) && tooltip.has(e.target).length === 0) {
			tooltip.hide();
			tooltip.closest('.detail').removeClass('active__detail');
		}
	});

	$('.menu__close').click(function (e) {
		$('.menu__bgd').hide();
		$('body').css('overflow-y', 'initial');
	});

	let timer = 0;
	const searchInputDebounceMs = 250;

	$(document).on('keyup', '.search_form input', function (event) {
		let _self = $(this);
		clearTimeout(timer);
		let restRequest = 0;

		timer = setTimeout(function () {
			let query = _self.val();
			let action = _self.closest('form').data('keyup');
			if (query.length > 1) {
				restRequest++;
				$('.search_form').addClass('loading');
				if (event.type === 'keyup') {
					$.get(action, { query: query }, function (result) {
						restRequest--;
						$('.search_form').removeClass('loading');
						let data = JSON.parse(result);
						SearchProductsQuery(query, data.eItems);
						$('.popup__input').html(data.products);
						UIkit.drop('.popup__input').show();
						$(body).addClass('open-drop-menu');
						if (data.categories) {
							$('.arrow__block').html(data.categories).show();
						}
						scroll_search();
					});
					(window.rrApiOnReady = window.rrApiOnReady || []).push(function () {
						try {
							rrApi.search(query);
						} catch (e) {}
					});
				} else {
					if ($.trim($('.popup__input').html()).length !== 0) {
						UIkit.drop('.popup__input').show();
						$(body).addClass('open-drop-menu');
						scroll_search();
					}
				}
			} else {
				if (query.length === 0) {
					let previous = _self.closest('form').data('previous');
					$.get(previous, function (result) {
						let data = JSON.parse(result);
						if (data.count > 0) {
							$('.popup__input').html(data.products);
							// UIkit.drop('.popup__input').show();
						} else {
							UIkit.drop('.popup__input').hide();
							$(body).removeClass('open-drop-menu');
							$('.arrow__block').hide();
						}
					});
				} else {
					UIkit.drop('.popup__input').hide();
					$(body).removeClass('open-drop-menu');
					$('.arrow__block').hide();
				}
			}
		}, searchInputDebounceMs);
	});


	$("input[name='query']").on("focus", function () {
		let popup = $(".popup__input");

		if (popup.find(".search-items").length > 0) {
			UIkit.drop('.popup__input').show();
			$(body).addClass('open-drop-menu');
		}
	});


	UIkit.util.on('.popup__input, .popup-search', 'hidden', function () {
		$(body).removeClass('open-drop-menu');
	});

	UIkit.util.on('.popup-search', 'show', function () {
		$(body).addClass('open-drop-menu');
	});

	$(document).on('submit', '.search_form', function (event) {
		let _self = $(this);
		let action = _self.attr('action');
		let query = action.split('=')[1];
		if (_self.find('input').val().length < 1 || query === '') {
			event.preventDefault();
		}
	});

	$(document).on('click', '.index-popup__list li', function (e) {
		$('.index-popup__list').find('li').removeClass('li_active');
		$(this).addClass('li_active');

		let value = $(this).data('id');
		let url = $(this).closest('.city__list').data('url');
		let popup = $(this).closest('.popup');

		$.post(
			url,
			{ value: value },
			function (data) {
				popup.removeClass('popup__open');
				$('.city_not_found').text('');
				$('.index-popup__input input').val('');
				$('.city_title').html(data.city);
			},
			'json'
		);
	});

	$(document).on('click', '.set_city_automatically', function () {
		let url = $(this).data('url');
		let popup = $(this).closest('.popup');
		$.post(
			url,
			function (data) {
				if (data.response) {
					popup.removeClass('popup__open');
					$('.city_not_found').text('');
					$('.index-popup__input input').val('');
					$('.city_title').html(data.city);
				} else {
					$('.city_not_found').text(data.message);
				}
			},
			'json'
		);
	});

	$(document).on("click", ".close__search", function () {
		UIkit.drop('.popup__input').hide();
	});

	$('.dropdown__img').click(function (e) {
		$(this).toggleClass('dropdown__img_active');
		$('.popup__arrow').toggle();
	});

	$(document).mouseup(function (e) {
		var container = $('.popup__arrow');
		if (container.has(e.target).length === 0) {
			$('.popup__arrow').hide();
			$('.dropdown__img').removeClass('dropdown__img_active');
		}
	});

	$('.header__catalog').click(function (e) {
		$(this).find('img').toggle();
		$(this).toggleClass('header__catalog_active');
		$('.catalog__popup').toggle();
	});

	$(document).click(function (e) {
		if (
			$(e.target).parents('.header__catalog').length === 0 &&
			$(e.target).parents('.catalog__popup').length === 0
		) {
			if ($('.header__catalog').hasClass('header__catalog_active')) {
				$('.header__catalog').find('img').toggle();
				$('.header__catalog').toggleClass('header__catalog_active');
				$('.catalog__popup').toggle();
			}
		}
	});

	$(document).click(function (e) {
		if ($(e.target).parents('.popup__cart').length === 0) {
			if ($('.popup__cart').hasClass('popup__open')) {
				$('.popup').removeClass('popup__open');
			}
		}
	});

	$('.footer__item')
		.not('.footer__item_last')
		.find('.footer-h5')
		.click(function () {
			$(this).parent().find('ul').slideToggle();
			$(this).toggleClass('footer-h5_active');
		});

	$('.simile__list')
		.find('li')
		.click(function (e) {
			$('.simile__list').find('li').removeClass('li_active');
			$(this).addClass('li_active');
		});

	$('.color__head').click(function (e) {
		$(this).parent().find('.color__body').toggle();
	});

	$('.product__func')
		.find('ul li')
		.click(function (e) {
			$('.product__func').find('ul li').removeClass('li__active');
			$(this).addClass('li__active');
		});

	$('.toggle_button').click(function (e) {
		e.preventDefault();
		$(this).parent().find('.toggle_text').toggleClass('text-open');
		let text = $(this).text();
		let newText = $(this).data('new');
		$(this).text(newText).data('new', text);
	});

	$(document).on('click', '.shares-head', function () {
		let current = $(this).parent().index();
		$('.shares').each(function (e) {
			if ($(this).index() !== current) $(this).removeClass('shares__open');
		});
		if ($(this).parent().hasClass('shares__open')) {
			$(this).parent().removeClass('shares__open');
		} else {
			$('.shares-head').parent().removeClass('shares__open');
			$(this).parent().addClass('shares__open');
		}
		$(this).parent().find('.list-select li a').first().trigger('click');
	});

	$('.credit .shares-head').click(function () {
		$('html, body').animate(
			{ scrollTop: $(this).offset().top - $('.header').height() },
			1000
		);
	});

	$(document).on('click', '.harak', function () {
		$('html, body').animate(
			{ scrollTop: $('#specifications').offset().top - $('.header').height() },
			500
		);
	});

	$(document).on('click', '.allrev', function () {
		$('html, body').animate(
			{ scrollTop: $('.reviews').offset().top - $('.header').height() },
			500
		);
	});

	$(document).on('click', '.list-select li', function () {
		$(this).closest('ul').find('li').removeClass('list_active');
		$(this).addClass('list_active');
	});

	$('.content-rht-item').click(function (e) {
		$('.content-rht-item').removeClass('content-rht-active');
		$(this).addClass('content-rht-active');
	});

	$(document).on('submit', '#subscribee', function (event) {
		event.preventDefault();
		let _self = $(this);
		let email = _self.find("input[type='email']").val();
		let url = _self.attr('action');
		$.post(
			url,
			{ email: email },
			function (data) {
				_self.find("input[type='email']").val('');
				_self.closest('.subscribe__block').find('.index-h3').html(data.message);
			},
			'json'
		);

		(window['rrApiOnReady'] = window['rrApiOnReady'] || []).push(function () {
			try {
				rrApi.setEmail(email, { language: lang });
			} catch (e) {}
		});
	});

	$(document).on('click', '.select_locality', function (event) {
		event.preventDefault();
		$('.popup__city').addClass('popup__open');

		let input = $('.index-popup__input input');
		let value = input.val();
		let url = input.data('url');

		$.post(
			url,
			{ value: value },
			function (data) {
				$('.city__list').html(data.html);
			},
			'json'
		);
	});

	$(document).on('keyup', '.index-popup__input input', function (event) {
		event.preventDefault();
		let value = $(this).val();
		let url = $(this).data('url');

		$.post(
			url,
			{ value: value },
			function (data) {
				$('.city__list').html(data.html);
			},
			'json'
		);
	});

	$(document).on('click', '.respond-vacancy', function (event) {
		event.preventDefault();
		let title = $(this).data('title');
		$('.block-vacancy h3').text(title);
		let id = $(this).data('id');
		$("input[name='vacancy[id]']").val(id);
		$('.popup__vacancy')
			.find('option')
			.each(function () {
				if ($(this).hasClass('vacancy-' + id)) {
					$(this).show();
				} else {
					$(this).hide();
					if ($(this).is(':selected')) {
						$('.magazin-head').val('');
					}
				}
			});
		$('.popup__vacancy').addClass('popup__open');
	});

	$(document).on('click', '.remove_popup', function (event) {
		event.preventDefault();
		$(this).closest('.popup').remove();
	});

	$(document).on('change', 'input[name="color"]', function () {
		const box = $(this).closest('.bv_data');
		const articol = box.data('articol');
		const size = box.data('size');
		const color = $(this).val();

		box.data('color', color);
		$('.bottom_pop').data('color', color);
		// get_disponible_sizes(articol, color, size);
	});

	$(document).on('change', 'input[name="size"]', function () {
		const box = $(this).closest('.bv_data');
		const articol = box.data('articol');
		const color = box.data('color');
		const size = $(this).val();

		box.data('size', size);
		$('.bottom_pop').data('size', size);
		get_disponible_colors(articol, color, size);
	});

	$(document).on('click', '.tooltip-close', function () {
		$(this).closest('.info').css('visibility', 'hidden');
	});

	$(document).on(
		'click',
		'.add_to_favorite, .delete_favorite',
		function (event) {
			event.preventDefault();
			const _self = $(this);
			const box = _self.closest('.bv_data');
			const id = box.data('id');

			$.post(
				'/' + lang + '/ajax/add_to_favorite/',
				{ id: id },
				function (result) {
					let data = JSON.parse(result);
					if (data.action === 'add') {
						_self.addClass('active');
						// Get a target item id
						const itemId = _self.data().ecom_id;
						// Select target element that contains data ecom attributes by its id
						let targetElement = document.querySelector(`[data-ecom_id='${itemId}']`);
						if (targetElement) {
							if (!targetElement.dataset.ecom_name) {
								targetElement = document.querySelector(`.ecommerce-list-data[data-ecom_id='${itemId}']`);
								if (targetElement) {
									AddToWishlist(targetElement.dataset);
								}
							} else {
								AddToWishlist(targetElement.dataset);
							}
						}
					} else {
						_self.removeClass('active');
						if (_self.hasClass('delete_favorite')) {
							window.location.reload();
						}
					}
					$('.favorite_count p').attr('data-count', data.count);
				}
			);
		}
	);

	$(document).on("click", ".add_to_compare, .delete_compare", function(event) {
		event.preventDefault();
		const _self = $(this);
		const box = _self.closest('.bv_data');
		const id = box.data('id');

		$.post('/' + lang + '/ajax/add_to_compare/', { id: id }, function (result) {
			let data = JSON.parse(result);
			if (data.action === 'add') {
				let data = JSON.parse(result);
				// Get a target item id
				const itemId = _self.data().ecom_id;
				// Select target element that contains data ecom attributes by its id
				let targetElement = document.querySelector(`[data-ecom_id='${itemId}']`);
				if (targetElement) {
					if (!targetElement.dataset.ecom_name) {
						targetElement = document.querySelector(`.ecommerce-list-data[data-ecom_id='${itemId}']`);
						if (targetElement) {
							AddToComparison(targetElement.dataset);
						}
					} else {
						AddToComparison(targetElement.dataset);
					}
				}

				_self.addClass('active');
				_self.closest('div').find('.info').css('visibility', 'visible');
				setTimeout(function () {
					_self.closest('div').find('.info').css('visibility', 'hidden');
				}, 2000);
			} else {
				_self.removeClass('active');
				_self.closest('div').find('.info').css('visibility', 'hidden');
				if (_self.hasClass('delete_compare')) {
					window.location.reload();
				}
			}
			$('.compare_count p').attr('data-count', data.count);
		});
	});

	$(document).on('click', '.list_clean', function (event) {
		event.preventDefault();

		if (confirm(window.translations.sure) === true) {
			const _self = $(this);
			const ids = _self.data('ids');

			$.post('/' + lang + '/ajax/list_clean/', { ids: ids }, function (result) {
				window.location.reload();
			});
		}
	});

	$(document).on('change', '#sr1', function () {
		if ($(this).is(':checked')) {
			$('.same').css('display', 'none');
			$('.settings__block').each(function () {
				let cnt1 = $(this).find('.settings__body').length;
				let cnt2 = $(this).find('.settings__body:hidden').length;

				if (cnt1 === cnt2) {
					$(this).find('h4').hide();
				}
			});
		} else {
			$('.same').css('display', 'flex');
			$('.settings__block').each(function () {
				$(this).find('h4').show();
			});
		}
	});

	$(document).on('click', '.header__menu > ul > li', function () {
		$(this).toggleClass('active');
	});

	$(document).on('change', '.credit_month', function () {
		let cType = $(this).data('type');
		$('.credit_type').val(cType);
	});

	$(document).on('click', '.close__search', function () {
		$('.search_form').find('input').val('');
	});

	$('.review__start-bv').each(function (i, obj) {
		let score = $(this).data('score');
		$(this).starRating({
			disableAfterRate: false,
			starSize: 20,
			readOnly: true,
			totalStars: 5,
			emptyColor: 'lightgray',
			activeColor: 'rgb(213 9 16)',
			initialRating: score,
			strokeWidth: 0,
			useGradient: false,
			minRating: 1,
		});
	});

	if ($(window).width() < 1200) {
		$(".filters__btn").css("bottom", "63px");
		$(".filters__btn").css("width", "100%");
	}

	imagesLazyLoad();
	setTimeout(() => {
		imagesLazyLoad();
	}, 2500);
});

$("input[name='query']").on("click", function (event) {
	let popup = $(".popup__input");
	if (popup.find(".search-items").length > 0) {
		event.stopPropagation();
	}
});

if (slider) {
	let isDown = false;
	let startX = 0;
	let scrollLeft = 0;
	const activateSlider = (e) => {
		isDown = true;
		slider.classList.add('active');
		startX = e.pageX - slider.offsetLeft;
		scrollLeft = slider.scrollLeft;
	};
	const deactivateSlider = () => {
		isDown = false;
		slider.classList.remove('active');
	};
	const handleMouseMove = (e) => {
		if (!isDown) return;
		e.preventDefault();
		const x = e.pageX - slider.offsetLeft;
		const walk = (x - startX) * 3; // Скорость прокрутки
		slider.scrollLeft = scrollLeft - walk;
	};
	// Привязка обработчиков событий
	slider.addEventListener('mousedown', activateSlider);
	slider.addEventListener('mouseleave', deactivateSlider);
	slider.addEventListener('mouseup', deactivateSlider);
	slider.addEventListener('mousemove', handleMouseMove);
}

function setCookie(name, value, days) {
	const d = new Date();
	d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
	const expires = "expires=" + d.toUTCString();
	document.cookie = name + "=" + value + ";" + expires + ";path=/";
}
function getCookie(name) {
	const nameEQ = name + "=";
	const ca = document.cookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
}
function debounce(func, wait) {
	let timeout;
	return function(...args) {
		const later = () => {
			clearTimeout(timeout);
			func.apply(this, args);
		};
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
	};
}

function isElementInViewport(el) {
	const rect = el.getBoundingClientRect();
	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
		rect.right <= (window.innerWidth || document.documentElement.clientWidth)
	);
}

function isElementWithinContainer(el, container) {
	const elRect = el.getBoundingClientRect();
	const containerRect = container.getBoundingClientRect();
	return (
		elRect.top >= containerRect.top &&
		elRect.bottom <= containerRect.bottom &&
		elRect.left >= containerRect.left &&
		elRect.right <= containerRect.right
	);
}

function extractVisibleProductIds() {
	let productData = [];
	$('.product__list .product__item:visible').each(function() {
		const container = $(this).closest('.product__list')[0];
		if (isElementInViewport(this) && isElementWithinContainer(this, container)) {
			let productId = $(this).data('id');
			let listId = $(this).data('list_id');
			let listName = $(this).data('list_name');
			if (productId) {
				productData.push({
					id: productId,
					list_id: listId,
					list_name: listName
				});
			}
		}
	});
	////console.log('productData: ', productData);
	return productData;
}

document.addEventListener('DOMContentLoaded', function() {
	const debouncedHandleViewChange = debounce(handleViewChange, 200);
	eraseCookie('product_view_data');
	handleViewChange();

	const observer = new MutationObserver(function(mutationsList, observer) {
		debouncedHandleViewChange();
	});

	const ajaxListElements = document.querySelectorAll('.product__list');
	ajaxListElements.forEach(element => {
		observer.observe(element, {
			childList: true,
			subtree: true
		});
	});

	$(window).on('scroll', function() {
		debouncedHandleViewChange();
	});

	var clickableBlocks = document.querySelectorAll('.label-show');
	clickableBlocks.forEach(function(block) {
		block.addEventListener('click', function() {
			var parent = block.closest('.label-wrapper');
			if (parent) {
				parent.classList.toggle('uk-active');
			}
		});
	});

	// Ecommerce Begin checkout | Standard Purchase
	const personalDataInput = document.querySelector(`div.block-pay input[name='personal_data']`);
	const termsAndCondInput = document.querySelector(`div.block-pay input[name='terms']`);
	const beginCheckout = function() {
		// Call ecommerce method
		fetch(`/${lang}/ajax/begin_checkout_btn/`, {method: 'POST'})
			.then(response => response.json())
			.then(data => BeginCheckout(data.ecommerce_items))
		;
	}

	if (personalDataInput && termsAndCondInput) {
		personalDataInput.addEventListener('click', function() {
			if (this.checked && termsAndCondInput.checked) {
				beginCheckout();
			}
		});

		termsAndCondInput.addEventListener('click', function() {
			if(this.checked && personalDataInput.checked) {
				beginCheckout();
			}
		});
	}

});

function checkImageStatus() {
	const skeletons = document.querySelectorAll('.skeleton');

	skeletons.forEach(skeleton => {
		const images = skeleton.classList.contains('main-slider')
			? [skeleton.querySelector('img')].filter(Boolean)
			: skeleton.querySelectorAll('img');
		let allLoaded = true;

		images.forEach(img => {
			if (!img.complete || (img.naturalWidth === 0)) {
				allLoaded = false; // Найдено хотя бы одно изображение, которое еще не загружено
			}
		});

		if (allLoaded) {
			skeleton.classList.remove('skeleton'); // Удаляем класс, если все изображения загружены
		}
	});
}
setInterval(checkImageStatus, 500);

function get_disponible_sizes(articol, color, size) {
	$.post(
		'/' + lang + '/ajax/get_disponible_sizes/',
		{ articol: articol, color: color, size: size },
		function (data) {
			let box = $('.prod_size');
			let res = jQuery.parseJSON(data);

			box.find('label span').removeClass('disabled');
			box.find('label').css('pointer-events', 'auto');

			let array = $.map(res.ids, function (value, index) {
				return [value];
			});

			box.find('input').each(function (index) {
				let size = $(this).val();
				if (jQuery.inArray(size.toString(), array) === -1) {
					$(this).parents('label').find('span').addClass('disabled');
					$(this).parents('label').css('pointer-events', 'none');
				}
			});

			if (res.code !== null) {
				$('#code').text(res.code);
				$('.bv_data').data('id', res.code);
			}
			$('.prod_btn').html(res.productBtn);
		}
	);
}

function get_disponible_colors(articol, color, size) {
	$.post(
		'/' + lang + '/ajax/get_disponible_colors/',
		{ articol: articol, color: color, size: size },
		function (data) {
			let box = $('.prod_color');
			let res = jQuery.parseJSON(data);

			box.find('label span').removeClass('disabled');
			box.find('label').css('pointer-events', 'auto');

			let array = $.map(res.ids, function (value, index) {
				return [value];
			});

			box.find('input').each(function (index) {
				let color = $(this).val();
				if (jQuery.inArray(color.toString(), array) === -1) {
					$(this).parents('label').find('span').addClass('disabled');
					$(this).parents('label').css('pointer-events', 'none');
				}
			});
			if (res.code !== null) {
				$('#code').text(res.code);
				$('.bv_data').data('id', res.code);
			}
			$('.prod_btn').html(res.productBtn);
		}
	);
}

function eraseCookie(name) {
	document.cookie = name + '=; Max-Age=0; path=/;';
}
eraseCookie('sentProductIds');

$(document).on('click', '#checkout_btn', function (e) {
	e.preventDefault();

	// const url = $(this).attr('href');
	// let product_id = $(this).data('product_id');
	//
	// $.post(
	// 	'/' + lang + '/ajax/begin_checkout_btn/',
	// 	{ product_id: product_id },
	// 	function (data) {
	// 		BeginCheckout(data.ecommerce_items);
	// 		// BeginCheckout(data.eItems, data.eCode);
	// 		if (url) {
	// 			window.location.href = url;
	// 		}
	// 	},
	// 	'json'
	// );

	let data_delivery = $('.delivery_wr :input');

	$.post('/' + lang + '/ajax/set_delivery/', data_delivery, function (response) {
		let data = JSON.parse(response);
		// Ecommerce add shipping info
		AddShippingInfo(data.ecommerce_items, data.eCode, data.eShipping);
	});
});

document.addEventListener('DOMContentLoaded', () => {
	function removeActivityClasses() {
		const menuContainer = document.querySelector('.mobile_menu_container .activity');
		if (menuContainer) {
			setTimeout(function() { menuContainer.scrollTo({ top: 0})}, 150);
		}
		document.querySelectorAll('.mobile_menu_container .activity').forEach(el => el.classList.remove('activity'));
	}

	document.addEventListener('click', (event) => {
		const parentLink = event.target.closest('.mobile_menu_container .parent')
		if (parentLink) {
			event.preventDefault()
			removeActivityClasses()
			const submenu = parentLink.nextElementSibling
			submenu.classList.add('loaded', 'activity')
		}
	})

	document.addEventListener('click', (event) => {
		const backLink = event.target.closest('.mobile_menu_container .back')
		if (backLink) {
			event.preventDefault()
			removeActivityClasses()
			const parentUL = backLink.parentElement.parentElement
			parentUL.classList.remove('loaded')
			parentUL.parentElement.parentElement.classList.add('activity')
		}
	})

	const sliders = document.querySelectorAll('.slider-count');

	sliders.forEach(sliderContainer => {
		const activeSlideNumber = sliderContainer.querySelector('.active-slide-number');
		const totalSlides = sliderContainer.querySelector('.total-slides');
		const sliderElement = sliderContainer.closest('.uk-slider, .uk-slideshow');

		if (!sliderElement || !activeSlideNumber || !totalSlides) {
			console.error('Required elements not found for slider:', sliderContainer);
			return;
		}

		let slideshow;
		if (sliderElement.classList.contains('uk-slider')) {
			slideshow = UIkit.slider(sliderElement);
		} else if (sliderElement.classList.contains('uk-slideshow')) {
			slideshow = UIkit.slideshow(sliderElement);
		}

		if (!slideshow) {
			console.error('Failed to initialize slideshow for slider:', sliderContainer);
			return;
		}

		function updateActiveSlide() {
			const activeIndex = slideshow.getIndex ? slideshow.getIndex() : slideshow.index;
			activeSlideNumber.textContent = (activeIndex || 0) + 1;
			totalSlides.textContent = slideshow.slides.length;
		}

		updateActiveSlide();

		sliderElement.addEventListener('itemshow', updateActiveSlide);
	});

	const popup = new URLSearchParams(window.location.search).get('popup');

	if (popup === 'login') {
		document.querySelector('.buttons__personal_cabinet')?.click();
	}
});
//
// (function () {
// 	let jivoLoaded = false;
//
// 	const WIDGETS = {
// 		ru: 'https://code.jivosite.com/widget/SDTej26xaj',
// 		ro: 'https://code.jivosite.com/widget/V3QqlS14qQ'
// 	};
//
// 	const pickWidget = () => {
// 		const p = location.pathname;
// 		if (p === '/' || p.startsWith('/ro')) return WIDGETS.ro;
// 		if (p.startsWith('/ru')) return WIDGETS.ru;
// 	};
//
// 	function loadJivo() {
// 		return new Promise((resolve, reject) => {
// 			if (jivoLoaded || !pickWidget()) return resolve();
// 			const s = document.createElement('script');
// 			s.src = pickWidget();
// 			s.async = true;
// 			s.onload = () => { jivoLoaded = true; resolve(); };
// 			s.onerror = reject;
// 			document.head.appendChild(s);
// 		});
// 	}
//
// 	const btn = document.getElementById('help');
// 	if (!btn) return;
//
// 	btn.addEventListener('click', async (e) => {
// 		e.stopPropagation();
// 		if (btn.classList.contains('is-loading')) return;
// 		btn.classList.add('is-loading');
// 		await loadJivo();
//
// 		const openJivo = () => window.jivo_api && window.jivo_api.open();
//
// 		openJivo();
//
// 		const t = setInterval(() => {
// 			if (openJivo()) {
// 				clearInterval(t);
// 				btn.remove();
// 			}
// 		}, 300);
// 	});
//
//
// })();
//
// //Open Opening Jivochat when clicking a custom button
//
// (function () {
// 	const btn  = document.getElementById('open-jivo');
// 	const help = document.getElementById('help');
// 	if (!btn || !help) return;
//
// 	const tryOpen = () => {
// 		if (window.jivo_api && typeof window.jivo_api.open === 'function') {
// 			window.jivo_api.open();
// 			return true;
// 		}
// 		return false;
// 	};
//
// 	let loaderTriggered = false;
//
// 	btn.addEventListener('click', () => {
// 		if (tryOpen()) return;
//
// 		if (!loaderTriggered) {
// 			loaderTriggered = true;
// 			help.click();
// 			const t = setInterval(() => {
// 				if (tryOpen()) clearInterval(t);
// 			}, 300);
// 		}
// 	});
// })();

const ENERGY_ITEMS = {
	1: [
		{mark: 'A+++', bg: '#009842'},
		{mark: 'A++', bg: '#48B233'},
		{mark: 'A+', bg: '#C2D500'},
		{mark: 'A', bg: '#FDF100'},
		{mark: 'B', bg: '#F9BC00'},
		{mark: 'C', bg: '#EB6B00'},
		{mark: 'D', bg: '#E30115'}
	],
	2: [
		{mark: 'A', bg: '#009842'},
		{mark: 'B', bg: '#48B233'},
		{mark: 'C', bg: '#C2D500'},
		{mark: 'D', bg: '#FDF100'},
		{mark: 'E', bg: '#F9BC00'},
		{mark: 'F', bg: '#EB6B00'},
		{mark: 'G', bg: '#E30115'}
	]
};

const MODAL_TEXTS = {
	title: {ro: 'Etichetarea energetică a mărfurilor', ru: 'Энергетическая маркировка товаров'},
	description: {ro: 'Mai jos este indicată clasa de eficiență energetică a dispozitivului.', ru: 'Ниже указан класс энергоэффективности прибора.'},
	moreLink: {ro: 'Aflați mai multe', ru: 'Узнать больше'},
	oldMark: {ro: 'Clasa energetică de tip vechi', ru: 'Старая энергетическая маркировка'},
	newMark: {ro: 'Clasa energetică de tip nou', ru: 'Новая энергетическая маркировка'},
	currentClass: {ro: 'Clasa curentă de produs', ru: 'Класс текущего товара'},
	link: {ro: '/ro/stiri/noua-clasa-energetica-a-aparatelor-electrocasnice-64/', ru: '/ru/novosti/novaya-energeticheskaya-markirovka-byitovoy-tehniki-64/'}
};

function getEnergyListHtml(activeMark, type) {
	var items = ENERGY_ITEMS[type] || ENERGY_ITEMS[2];
	var currentClassText = MODAL_TEXTS.currentClass[lang];

	return items.map(function(item) {
		var isActive = item.mark === activeMark;
		var activeClass = isActive ? 'uk-active' : '';
		var textSpan = isActive ? `<span class="text">${currentClassText}</span>` : '';
		return `<li class="${activeClass}" style="--bg:${item.bg}"><span>${item.mark}</span>${textSpan}</li>`;
	}).join('');
}

document.addEventListener('click', function(e) {
	// Находим кнопку с классом modal-energy среди родительских элементов
	var btn = e.target.closest('.modal-energy');
	if (!btn) return;

	e.preventDefault();
	btn.blur();

	var mark = btn.getAttribute('data-mark') || 'E';
	var type = btn.getAttribute('data-type') || '2';
	var classLabel = (type == 1) ? MODAL_TEXTS.oldMark[lang] : MODAL_TEXTS.newMark[lang];

	var modalHtml = `
        <button class="uk-modal-close-default uk-icon uk-close" type="button" uk-close aria-label="Close"></button>
        <p class="title">${MODAL_TEXTS.title[lang]}</p>
        <p>${MODAL_TEXTS.description[lang]}</p>
        <p class="uk-text-muted uk-margin-top">${classLabel}</p>
        <ul>${getEnergyListHtml(mark, type)}</ul>
        <a href="${MODAL_TEXTS.link[lang]}" class="link" target="_blank">${MODAL_TEXTS.moreLink[lang]}</a>
    `;

	UIkit.modal.dialog(modalHtml, {clsPage: 'modal-energy-dialog'});
});



window.debounce = debounce;
window.getCookie = getCookie;
window.setCookie = setCookie;
window.eraseCookie = eraseCookie;
window.extractVisibleProductIds = extractVisibleProductIds;

// Full-page cache: header badges AND per-card active icons (cart / compare /
// favorite) are baked into the cached HTML, so they are frozen for anonymous
// hits. Re-fetch the current session's real state after load and apply it. The
// /ajax/ path is excluded from the full-page cache, so this is always per-user.
function hydrateUserState() {
	fetch(`/${lang}/ajax/counts/`, {credentials: 'same-origin'})
		.then((response) => (response.ok ? response.json() : null))
		.then((data) => {
			if (!data) return;

			// Header badges
			$('.cart_num').attr('data-count', data.cart);
			$('.compare_count p').attr('data-count', data.compare);
			$('.favorite_count p').attr('data-count', data.favorite);

			// Personal-cabinet button (login vs. profile) is frozen by the
			// full-page cache; replace it with the real per-session render.
			if (data.personal_cabinet_html) {
				$('.header__buttons .buttons__personal_cabinet').replaceWith(data.personal_cabinet_html);
			}

			// Same fix for the mobile bottom-nav button, which is a separate
			// element the desktop selector above never touches.
			if (data.personal_cabinet_mobile_html) {
				$('.menu-btn-center').html(data.personal_cabinet_mobile_html);
			}

			// The mobile "account" popup panel only exists in the DOM when the
			// page was originally rendered for a logged-in visitor. Inject it
			// if a cached anonymous page turns out to belong to a real session.
			if (data.account_popup_mobile_html && !document.getElementById('account-popup-modal-mb')) {
				$('body').append(data.account_popup_mobile_html);
			}

			// Product-card active icons. Match by the same product id source the
			// click handlers use: .bv_data[data-id]. toggleClass corrects BOTH
			// directions, so any stale-active from the cached HTML is cleared too.
			const cart = new Set((data.cart_ids || []).map(String));
			const compare = new Set((data.compare_ids || []).map(String));
			const favorite = new Set((data.favorite_ids || []).map(String));

			$('.bv_data').each(function () {
				const $card = $(this);
				const id = String($card.data('id'));

				$card.find('.add_to_favorite').toggleClass('active', favorite.has(id));
				$card.find('.add_to_compare').toggleClass('active', compare.has(id));
				$card.find('.check_color_and_size').toggleClass('uk-active', cart.has(id));
			});
		})
		.catch(() => {});
}

$(hydrateUserState);
